import ReduxHelper from 'lib/ReduxHelper';

export const GARAGES_ACTION_TYPES = {
  GARAGES_FETCH_DATA: 'GARAGES_FETCH_DATA',
  GARAGES_FETCH_DATA_SUCCESS: 'GARAGES_FETCH_DATA_SUCCESS',
  GARAGES_FETCH_DATA_FAIL: 'GARAGES_FETCH_DATA_FAIL',
  GARAGES_CLEAR_DATA: 'GARAGES_CLEAR_DATA',

  GARAGE_FETCH: 'GARAGE_FETCH',
  GARAGE_FETCH_SUCCESS: 'GARAGE_FETCH_SUCCESS',
  GARAGE_FETCH_FAIL: 'GARAGE_FETCH_FAIL',
  GARAGE_CLEAR: 'GARAGE_CLEAR',

  GARAGE_CREATE: 'GARAGE_CREATE',
  GARAGE_CREATE_SUCCESS: 'GARAGE_CREATE_SUCCESS',
  GARAGE_CREATE_FAIL: 'GARAGE_CREATE_FAIL',
  GARAGE_CREATE_CLEAR: 'GARAGE_CREATE_CLEAR',

  GARAGE_UPDATE: 'GARAGE_UPDATE',
  GARAGE_UPDATE_SUCCESS: 'GARAGE_UPDATE_SUCCESS',
  GARAGE_UPDATE_FAIL: 'GARAGE_UPDATE_FAIL',
  GARAGE_UPDATE_CLEAR: 'GARAGE_UPDATE_CLEAR',

  GARAGE_DELETE: 'GARAGE_DELETE',
  GARAGE_DELETE_SUCCESS: 'GARAGE_DELETE_SUCCESS',
  GARAGE_DELETE_FAIL: 'GARAGE_DELETE_FAIL',
  GARAGE_DELETE_CLEAR: 'GARAGE_DELETE_CLEAR',

  SET_GARAGES_GRID_FILTER: 'SET_GARAGES_GRID_FILTER',
  CLEAR_GARAGES_GRID_FILTER: 'CLEAR_GARAGES_GRID_FILTER',
};

export const fetchGaragesData = id =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGES_FETCH_DATA, {
    GarageId: id,
  });

export const searchGarages = searchTerm =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGES_FETCH_DATA, {
    AFM: searchTerm,
  });

export const fetchGarage = id =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGE_FETCH, id);
export const clearGarage = id =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGE_CLEAR);
export const createGarage = garageData =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGE_CREATE, garageData);
export const updateGarage = garageData =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGE_UPDATE, garageData);
export const deleteGarage = id =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGE_DELETE, id);

export const clearGaragesData = () =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.GARAGES_CLEAR_DATA);

export const setGridFilter = (filterName, filterValue) =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.SET_GARAGES_GRID_FILTER, {
    name: filterName,
    value: filterValue,
  });
export const clearGridFilter = () =>
  ReduxHelper.createAction(GARAGES_ACTION_TYPES.CLEAR_GARAGES_GRID_FILTER);
